<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardTitle class="text-center" style="color: #fdcc05">{{
        $t("partialAdmission")
      }}</VCardTitle>
      <VCardText>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
          <form @submit.prevent="handleSubmit(openWarningDialog)">
            <div class="py-2">
              <CustomInputText
                :label="$t('enterAmount')"
                only="number"
                :rules="{
                  required: true,
                  max_value: contractItemCount,
                  less_than: contractItemCount,
                }"
                v-model="contractItemDecision.amount"
                class="user_input no-margin"
              ></CustomInputText>
            </div>
            <div class="py-2">
              <CustomTextTextarea
                rules="required"
                :label="$t('leaveComment')"
                class="user_input"
                v-model="contractItemDecision.description"
              ></CustomTextTextarea>
            </div>
            <VFileInput
              v-model="contractItemDecision.files"
              :label="$t('attachFile')"
            ></VFileInput>
            <div class="text-right">
              <VBtn type="submit" color="primary">{{ $t("send") }}</VBtn>
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
    <WarningDialog
      @apply="send"
      v-model="confirmDialog"
      ref="confirmDialogRef"
      yesText="yes"
    >
      {{
        $t("thinkDefective", {
          count: contractItemCount - contractItemDecision.amount,
          unitType: unitTypeName,
        })
      }}
    </WarningDialog>
  </VDialog>
</template>

<script>
import WarningDialog from "@/components/ui/prompt/warning-dialog.vue";
const DEFAULT_CONTRACT_ITEM_DECISION = {
  amount: null,
  contractItemId: null,
  files: null,
  description: null,
};
export default {
  data() {
    return {
      dialog: false,
      contractItemCount: null,
      contractItemDecision: {
        ...DEFAULT_CONTRACT_ITEM_DECISION,
      },
      confirmDialog: false,
      unitTypeName: null,
    };
  },
  components: {
    WarningDialog,
  },
  watch: {
    dialog(val) {
      if (!val) this.clear();
    },
  },
  methods: {
    clear() {
      this.contractItemDecision = {
        ...DEFAULT_CONTRACT_ITEM_DECISION,
      };
      this.$refs.formObs.reset();
    },
    openWarningDialog() {
      this.$refs.confirmDialogRef.open();
    },
    async send() {
      this.showLoading();
      try {
        const formData = new FormData();
        const { amount, contractItemId, description, files } =
          this.contractItemDecision;
        formData.append("accept", amount);
        formData.append("contractItemId", contractItemId);
        formData.append("description", description);
        formData.append("files", files);

        await this.$http.post("/contract/part-accept-item", formData);
        this.$emit("updateTableData");
        this.setSuccess({ text: this.$t("successfullySent") });
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open(contractItemId, count, acceptedCount, rejectedCount, unitTypeName) {
      this.contractItemDecision.contractItemId = contractItemId;
      this.contractItemCount = +count - acceptedCount - rejectedCount;
      this.dialog = true;
      this.unitTypeName = unitTypeName;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
